<template>
  <span>
    <v-layout align-center justify-start row wrap style="max-width: 362px">
      <h4 class="white--text mr-4 hidden-xs-only">ACESSIBILIDADE</h4>
      <span
        class="square mr-20"
        style="border: 1px solid #575757; background: #575757; color: white"
        @click="enableHighContrast()"
        >A</span
      >
      <span
        class="square mr-20"
        style="border: 1px solid white; background: white; color: black"
        @click="disableHighContrast()"
        >A</span
      >
      <span
        class="square mr-20"
        style="border: 1px solid white; color: white"
        @click="incrementFont()"
        >A+</span
      >
      <span
        class="square mr-20"
        style="border: 1px solid white; color: white"
        @click="resetFont()"
        >A</span
      >
      <span
        class="square"
        style="border: 1px solid white; color: white"
        @click="decrementFont()"
        >A-</span
      >
    </v-layout>
  </span>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapMutations } = createNamespacedHelpers("portal");

export default {
  name: "Accessibility",
  methods: {
    ...mapMutations([
      "incrementFont",
      "decrementFont",
      "resetFont",
      "enableHighContrast",
      "disableHighContrast"
    ])
  }
};
</script>

<style scoped>
.square {
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.mr-20 {
  margin-right: 20px;
}
h4 {
  font-size: 14px !important;
  font-weight: 400;
}
@media screen and (max-width: 600px) {
  .square {
    width: 22px;
    height: 22px;
    line-height: 22px;
  }
  .mr-20 {
    margin-right: 8px;
  }
}
</style>
